export default function Footer() {
  const year = 2026;
  return (
    <footer data-testid="site-footer" style={{ padding: "48px 0 40px", borderTop: "1px solid var(--rule)" }}>
      <div className="mx-auto footer-row" style={{ maxWidth: 1440, padding: "0 40px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 24, flexWrap: "wrap" }}>
        <div className="font-serif" style={{ fontSize: 18, letterSpacing: "-0.005em" }}>The Cutdown Club</div>
      </div>

      <div className="mx-auto font-mono footer-meta" style={{ maxWidth: 1440, padding: "32px 40px 0", fontSize: 11, letterSpacing: "0.14em", textTransform: "uppercase", color: "var(--ink-muted)", display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 10 }}>
        <span>© The Cutdown Club · Barcelona · {year}</span>
        <span>Made with care · Not at scale</span>
      </div>
    </footer>
  );
}
